export function focusAfterContentInInput(input?: HTMLInputElement): void {
  input?.focus();
  input?.setSelectionRange(input.value.length, input.value.length);
}
